import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ContenidoPaqueteDTO;
import { columnas } from "./columns";
const resource = resources.ContenidoPaquete;
export class ContenidoPaqueteList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar ContenidoPaquete?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    items = observeResource(resource.query);
    onEdit = (x: Entity) => history.go("/catalogos/ContenidoPaquete/" + x.IdRegistro);
    onAgregar = () => history.go("/catalogos/ContenidoPaquete/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Contenidos de paquete" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"ContenidoPaqueteListCookieKey"} items={this.items} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/contenidopaquete/list/list.tsx